import React from 'react';
import { motion } from 'framer-motion';
export function ManifestoSection() {
  return <section id="manifiesto" className="py-24 px-6 md:px-12 bg-cream" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy text-cream p-10 md:p-16 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-92">
          {/* Subtle decorative accent */}
          <div className="absolute top-0 left-0 w-2 h-full bg-marigold" data-id="element-93"></div>

          <span className="text-xs font-sans font-bold uppercase tracking-[0.2em] text-marigold/80 mb-8 block" data-id="element-94">
            Manifiesto
          </span>

          <div className="mb-8 font-serif tracking-wide text-marigold/90 text-xl md:text-2xl italic" data-id="element-95">
            familiar /fa-'mil-yar/ · adjective — well known from long or close
            association.
          </div>

          <div className="font-serif tracking-wide text-2xl md:text-3xl leading-snug md:leading-snug text-cream/90" data-id="element-96">
            <p data-id="element-97">
              Familiar spaces are places where one knows and is known. In an
              increasingly isolated world, we intentionally design environments
              that foster interaction, mutual care, and generosity.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}